'use client'
import { PrismicLink, PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import { v4 as uuidv4 } from 'uuid';
import React, { useState, useEffect } from "react";
import { createClient } from "@/prismicio"; // adapte le chemin selon ton projet
import { PrismicNextLink } from "@prismicio/next";
import axios from "axios";

/**
 * @typedef {import("@prismicio/client").Content.SearchSlice} SearchSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<SearchSlice>} SearchProps
 * @type {import("react").FC<SearchProps>}
*/
const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoieWVzeWVzcGFkZWwiLCJhIjoiY21mY3F5N3k2MDFhdDJtczMyNTVhb2swbSJ9.W7qduyKmwajnJcWq8JNX0A"
const Search = ({ slice }) => {
  const { title, text, no_result, new_city } = slice.primary;
  const [villes, setVilles] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredVilles, setFilteredVilles] = useState([]);
  const [mapboxSuggestions, setMapboxSuggestions] = useState([]);
  const [closestVille, setClosestVille] = useState([]);
  const [hasFetchedClosestVilles, setHasFetchedClosestVilles] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchVilles = async () => {
      const client = createClient();
      const response = await client.getAllByType("ville");
      setVilles(response);
    };
    fetchVilles();
  }, []);

  const filterVilles = async (search) => {
    setClosestVille([]);
    setHasFetchedClosestVilles(false);
    setMapboxSuggestions([]);
    setFilteredVilles([]);
    setSearch(search);
    const searchLower = search.toLowerCase();
    if (searchLower.length !== 0) {
      console.log(searchLower);
      const filteredVilles = villes.filter((ville) => {
        const nom = ville.data.nom?.toLowerCase() || "";
        const tags = ville.tags?.join(" ").toLowerCase() || "";
        console.log(nom, tags);
        if (nom.includes(searchLower) || tags.includes(searchLower)) {
          return ville;
        }
      });
      console.log(filteredVilles);
      if (filteredVilles.length !== 0) {
        setFilteredVilles(filteredVilles);
      }
      else {
        console.log("filteredVilles", filteredVilles);
        setFilteredVilles(filteredVilles);
        const uuid = uuidv4();
        const response = await axios.get(`https://api.mapbox.com/search/searchbox/v1/suggest`,
          { params: { q: searchLower, access_token: MAPBOX_ACCESS_TOKEN, session_token: uuid, country: 'fr', language: 'fr', limit: 4, types: 'city,postcode', poi_category: 'city' } });
        console.log(response.data.suggestions);
        setMapboxSuggestions(response.data.suggestions);
      }
    }
  }
  const getClosestVille = async (suggestion) => {
    setLoading(true);
    setSearch(suggestion.name);
    const uuid = uuidv4();
    const response = await axios.get(`https://api.mapbox.com/search/searchbox/v1/retrieve/${suggestion.mapbox_id}`,
      {
        params: {
          access_token: MAPBOX_ACCESS_TOKEN,
          session_token: uuid
        }
      });
    const lat = response.data.features[0].geometry.coordinates[1];
    const lng = response.data.features[0].geometry.coordinates[0];
    const clubResponse = await axios.get('https://app.yesyespadel.com/api/clubs/closest', { params: { lat, lng } })
    setClosestVille(clubResponse.data);
    setHasFetchedClosestVilles(true)
    console.log(clubResponse.data);
    setLoading(false);
  }
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="framing bg-white mt-16 mb-26 md:mt-20 md:mb-30 text-dark-green"
    >
      <div className="max-w-375 mx-auto w-full">
        <div className="flex flex-col gap-9">
          <div className="flex flex-col gap-5 md:text-center">
            {isFilled.richText(title) && (
              <PrismicRichText
                field={title}
                components={{
                  heading1: ({ children }) => (
                    <h1 className="h2-bold">{children}</h1>
                  ),
                  heading2: ({ children }) => (
                    <h2 className="h2-bold">{children}</h2>
                  ),
                  heading3: ({ children }) => (
                    <h3 className="h2-bold">{children}</h3>
                  ),
                }}
              />
            )}
            {isFilled.richText(text) && (
              <PrismicRichText
                field={text}
                components={{
                  paragraph: ({ children }) => (
                    <p className="max-w-300 mx-auto">{children}</p>
                  ),
                }}
              />
            )}
          </div>
          {/* Barre de recherche */}
          <div className="bg-green py-4 px-5 rounded-[16px] max-w-140 mx-auto w-full transition-all flex flex-col gap-2">
            <div className="relative flex items-center">
              <span className="absolute left-3">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M8.25 1.74012C7.36358 1.74012 6.48583 1.91472 5.66689 2.25394C4.84794 2.59316 4.10382 3.09036 3.47703 3.71715C2.85023 4.34395 2.35303 5.08806 2.01381 5.90701C1.67459 6.72596 1.5 7.6037 1.5 8.49012C1.5 9.37655 1.67459 10.2543 2.01381 11.0732C2.35303 11.8922 2.85023 12.6363 3.47703 13.2631C4.10382 13.8899 4.84794 14.3871 5.66689 14.7263C6.48583 15.0655 7.36358 15.2401 8.25 15.2401C10.0402 15.2401 11.7571 14.529 13.023 13.2631C14.2888 11.9972 15 10.2803 15 8.49012C15 6.69991 14.2888 4.98302 13.023 3.71715C11.7571 2.45128 10.0402 1.74012 8.25 1.74012ZM4.98824e-08 8.49012C0.000174971 7.16522 0.31944 5.85985 0.930789 4.68442C1.54214 3.509 2.42759 2.4981 3.51224 1.73724C4.59689 0.976386 5.84883 0.487948 7.16216 0.313248C8.4755 0.138547 9.81159 0.282723 11.0574 0.733579C12.3033 1.18444 13.4222 1.92871 14.3195 2.90344C15.2169 3.87818 15.8663 5.0547 16.2128 6.33348C16.5594 7.61227 16.5928 8.9557 16.3103 10.2501C16.0278 11.5446 15.4378 12.752 14.59 13.7701L19.28 18.4601C19.3537 18.5288 19.4128 18.6116 19.4538 18.7036C19.4948 18.7956 19.5168 18.8949 19.5186 18.9956C19.5204 19.0963 19.5018 19.1963 19.4641 19.2897C19.4264 19.3831 19.3703 19.4679 19.299 19.5392C19.2278 19.6104 19.143 19.6665 19.0496 19.7042C18.9562 19.742 18.8562 19.7605 18.7555 19.7587C18.6548 19.7569 18.5555 19.7349 18.4635 19.6939C18.3715 19.6529 18.2887 19.5938 18.22 19.5201L13.53 14.8301C12.3252 15.8336 10.8594 16.473 9.30432 16.6734C7.74922 16.8738 6.16922 16.6268 4.74941 15.9615C3.3296 15.2962 2.12878 14.2401 1.28763 12.9169C0.44648 11.5936 -0.000172339 10.0581 4.98824e-08 8.49012Z" fill="#1D1D1B" />
                </svg>
              </span>
              <input
                type="text"
                placeholder="Le code postal ou le nom..."
                value={search}
                onChange={(e) => filterVilles(e.target.value)}
                className="border rounded px-3 py-2 w-full pl-10"
              />
            </div>
            {/* Liste des villes */}
            {search.trim() !== "" && (
              <div className="flex flex-col gap-2">
                <div className="bg-white rounded-sm text-dark-green border-1 border-dark-green text-base font-body overflow-hidden">
                  <ul>
                    {filteredVilles.length === 0 && mapboxSuggestions.length === 0 && closestVille.length === 0 ? (
                      <li className="px-4 py-2 text-dark-green/70 text-base">
                        {isFilled.keyText(no_result)
                          ? no_result
                          : "Nous n'avons pas encore de pistes ici ! Pour l’instant…"}
                      </li>
                    ) : (
                      filteredVilles.map((ville) => (
                        <li key={ville.id} className="w-full hover:bg-light-gray px-4 py-2">
                          {ville.tags && ville.tags.length > 0 && (
                            <PrismicNextLink
                              document={ville}
                              className="text-dark-green no-underline cursor-pointer w-full block text-base"
                            >
                              {
                                ville.tags
                                  .filter(tag => isNaN(tag))
                                  .concat(
                                    ville.tags.filter(tag => !isNaN(tag))
                                  ).join(" - ")
                              }
                            </PrismicNextLink>
                          )}
                        </li>
                      ))
                    )}
                  </ul>
                  {mapboxSuggestions.length > 0 && filteredVilles.length === 0 && !loading && closestVille.length === 0 && !hasFetchedClosestVilles && (
                    <React.Fragment>
                      <p className="px-4 py-2 text-dark-green/70 text-xs">Chercher autour de: {search}</p>
                      <ul>
                        {mapboxSuggestions.map((suggestion, idx) => (
                          <li key={idx} onClick={() => getClosestVille(suggestion)} className="px-4 py-2 hover:bg-light-gray text-dark-green/70 text-base cursor-pointer">{suggestion.name} - {suggestion.place_formatted}</li>
                        ))}
                      </ul>
                    </React.Fragment>
                  )}
                  {loading && (
                    <div className="px-4 py-2 text-dark-green/70 text-base">Chargement...</div>
                  )}
                  {closestVille.length > 0 && (
                    <React.Fragment>
                      <p className="px-4 py-2 text-dark-green/70 text-xs">Nos terrains proche de : {search}</p>
                      <ul>
                        {closestVille.map((ville) => (
                          <li key={ville.id} className="px-4 py-2 hover:bg-light-gray text-dark-green/70 text-base cursor-pointer">
                            <a href={`/nos-sites/${ville.name.toLowerCase()}`}
                              className="flex justify-between w-full text-decoration-none no-underline">
                              <span>{ville.city} - {ville.postal_code}</span>
                              <span>{ville.distance} km</span>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </React.Fragment>
                  )}
                  {hasFetchedClosestVilles && closestVille.length === 0 && (
                    <div className="px-4 py-2 text-dark-green/70 text-base">Aucun terrain trouvé dans un rayon de 50 km</div>
                  )}
                </div>
                {isFilled.richText(new_city) && (
                  <PrismicRichText
                    field={new_city}
                    components={{
                      paragraph: ({ children }) => (
                        <p className="text-white">{children}</p>
                      ),
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
export default Search;
